/* eslint-disable no-undef */
import React from 'react';
import { connect } from 'react-redux';
import { useLoadScript, GoogleMap, Marker, InfoBox } from '@react-google-maps/api';
import { Icon } from 'semantic-ui-react';
import { findLatLongForBound } from './lib/Mapper';
import { MARKER_TYPE } from './lib/constants';
import { stopIconSvg, flagIconSvg } from '../../../map/constants';
import mapStyles from '../../../map/mapStyles.json';
// import { getMapUrl } from '../../../../HelperMethods/UtilityFunctions';

const showMarkers = (props) => {
  const { locations } = props;
  return (
    <>
      {locations && locations.length
        ? locations.map((location) => {
            const { lat, lng, type } = location;
            const resolved = type === MARKER_TYPE.RESOLVED_AT_MARKER ? <Icon name="check" /> : null;
            return (
              <Marker
                icon={{
                  url: `data:image/svg+xml;charset=utf-8,${encodeURIComponent(stopIconSvg())}`,
                  anchor: new google.maps.Point(20, 40),
                  strokeWeight: 8,
                }}
                position={{ lat, lng }}
                labelAnchor={new google.maps.Point(24, 68)}
                labelStyle={{
                  background: 'transparent',
                  fontSize: '12px',
                  fontFamily: 'JoynFontBook',
                  width: '70px',
                  height: '85px',
                }}
              >
                <>
                  {resolved ? (
                    <>
                      <InfoBox
                        position={location}
                        options={{
                          closeBoxURL: '',
                          enableEventPropagation: true,
                          pixelOffset: new google.maps.Size(10, -70),
                        }}
                      >
                        <div>
                          <img
                            src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(flagIconSvg())}`}
                            height="30px"
                            width="30px"
                          />
                        </div>
                      </InfoBox>
                      <InfoBox
                        position={location}
                        options={{
                          closeBoxURL: '',
                          enableEventPropagation: true,
                          pixelOffset: new google.maps.Size(20, -70),
                        }}
                      >
                        <div style={{ color: 'white' }}>{resolved}</div>
                      </InfoBox>
                    </>
                  ) : null}
                </>
              </Marker>
            );
          })
        : null}
    </>
  );
};

const CustomMap = (props) => {
  const { loadError, isLoaded } = useLoadScript({
    googleMapsApiKey: props.googleMapKey,
    // ...otherOptions
  });

  if (loadError) {
    return <div>Map cannot be loaded right now, sorry.</div>;
  }
  if (!isLoaded) {
    return <div>Map Loading.</div>;
  }

  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      onLoad={props.onMapMounted}
      zoom={8}
      options={{
        mapTypeId: 'satellite',
        styles: mapStyles,
        zoomControlOptions: {
          position: google.maps.ControlPosition.LEFT_BOTTOM,
        },
      }}
    >
      {showMarkers(props)}
    </GoogleMap>
  );
};

class TaskFormMap extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      locations: [],
    };
  }

  onMapMounted = (ref) => {
    this.map = ref;
    // when mounting map with markers, this block would be called
    if (this.map) {
      this.customFitToBounds();
    }
  };

  customFitToBounds = () => {
    if (!this.map) return;
    if (!google) return;
    const { task } = this.props;
    const bounds = new google.maps.LatLngBounds();
    const locations = findLatLongForBound(task);
    this.setState({
      locations,
    });
    // add locations to bounds
    if (locations.length > 0) {
      locations.forEach((location) => {
        const loc = new google.maps.LatLng(location.lat, location.lng);
        bounds.extend(loc);
      });
    } else {
      // setting default bounds
      bounds.extend(new google.maps.LatLng(48, -124));
      bounds.extend(new google.maps.LatLng(26, -78));
    }
    // auto zoom and auto center
    this.map.fitBounds(bounds); // auto-zoom
    this.map.panToBounds(bounds); // auto-center
  };

  render() {
    const { googleMapsKey } = this.props;
    return (
      <CustomMap
        googleMapKey={googleMapsKey}
        loadingElement={<div style={{ height: `100%` }} />}
        containerElement={<div style={{ height: `400px` }} />}
        mapElement={<div style={{ height: `100%` }} />}
        onMapMounted={this.onMapMounted}
        locations={this.state.locations}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const {
    appReducer: {
      settings: {
        common: { googleMapsKey },
      },
    },
  } = state;
  return {
    googleMapsKey,
  };
};

export default connect(mapStateToProps, null)(TaskFormMap);
